import { FETCH_ANALYZE_DATA_SUCCEEDED, UPDATE_FREQUENCY, FETCH_ANALYZE_POINTS_SUCCEEDED, UPDATE_VIEW, CLEAR_PARAMS } from 'web-interactives-dashboard-ui/actions/ActionTypes';
import { FREQUENCY, ANALYZE_VIEW } from 'web-interactives-dashboard-ui/constants/AnalyticsConstants';
import { getQueryParamsFromLocation } from 'web-interactives-dashboard-ui/utils/urls';
const initialSearchParams = getQueryParamsFromLocation(window.location);
const getParamValuesFromSearchParams = () => ({
  frequency: initialSearchParams.frequency,
  view: initialSearchParams.view
});
const isValidFrequency = frequency => Object.values(FREQUENCY).includes(frequency);
const isValidView = view => Object.values(ANALYZE_VIEW).includes(view);
export const DEFAULT_PARAMS = {
  frequency: FREQUENCY.WEEKLY,
  view: ANALYZE_VIEW.VIEWS
};
const getInitialParams = () => {
  const {
    frequency,
    view
  } = getParamValuesFromSearchParams();
  return {
    frequency: isValidFrequency(frequency) ? frequency : DEFAULT_PARAMS.frequency,
    view: isValidView(view) ? view : DEFAULT_PARAMS.view
  };
};
const initialState = {
  params: getInitialParams(),
  data: {
    analyzeResponse: {
      startDateInt: 0,
      endDateInt: 0,
      totals: {
        currentCounters: {
          views: 0,
          clicks: 0,
          clickRate: 0,
          formSubmissions: 0,
          formSubmissionsRate: 0
        },
        viewDelta: 0,
        clickDelta: 0,
        clickRateDelta: 0,
        formSubmissionRateDelta: 0,
        prevCounters: {
          views: 0,
          clicks: 0,
          clickRate: 0,
          formSubmissions: 0,
          formSubmissionsRate: 0
        }
      },
      byInteractiveTotals: {
        startDateInt: 0,
        endDateInt: 0,
        results: []
      },
      pointsSummaryResult: {
        startDateInt: 0,
        endDateInt: 0,
        results: []
      }
    }
  }
};
const analyze = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_ANALYZE_POINTS_SUCCEEDED:
      return Object.assign({}, state, {
        data: Object.assign({}, state.data, {
          analyzeResponse: Object.assign({}, state.data.analyzeResponse, {
            pointsSummaryResult: Object.assign({}, state.data.analyzeResponse.pointsSummaryResult, {
              results: action.response.results
            })
          })
        })
      });
    case FETCH_ANALYZE_DATA_SUCCEEDED:
      return Object.assign({}, state, {
        data: action.response
      });
    case UPDATE_FREQUENCY:
      return Object.assign({}, state, {
        params: {
          frequency: action.frequency,
          view: state.params.view
        }
      });
    case UPDATE_VIEW:
      return Object.assign({}, state, {
        params: {
          frequency: state.params.frequency,
          view: action.view
        }
      });
    case CLEAR_PARAMS:
      return Object.assign({}, state, {
        params: Object.assign({}, DEFAULT_PARAMS)
      });
    default:
      return state;
  }
};
export default analyze;